export default {
  name: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  initials: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  companyID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  stateID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  cityID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  development: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/branch/branch-form.js